import { useCallback, useMemo, useState } from "react"

import { MoreHorizRoundedIcon, MoreVertRoundedIcon } from "@l2r-front/l2r-icons"
import { PropTypes } from "@l2r-front/l2r-proptypes"

import { L2RMenu } from "../L2RMenu"
import { MoreButton } from "../MoreButton"

export const MoreMenu = (props) => {
    const {
        icon,
        menuConfig,
        color,
        direction,
        size,
        ...menuProps
    } = props

    const [menuAnchor, setMenuAnchor] = useState(null)

    const handleMenuOpen = useCallback((event) => {
        event.stopPropagation()
        setMenuAnchor(event.currentTarget)
    }, [setMenuAnchor])

    const handleMenuClose = useCallback(() => {
        setMenuAnchor(null)
    }, [setMenuAnchor])

    const config = useMemo(() => {
        return menuConfig.filter((item) => item.enabled)
            .map((item) => ({
                id: item.id,
                label: item.label,
                icon: item.icon,
                props: item.props,
            }))
    }, [menuConfig])

    if (config.length === 0) {
        return null
    }

    const buttonIcon = icon ? icon : direction === "vertical" ? MoreVertRoundedIcon : MoreHorizRoundedIcon

    return <>
        <MoreButton color={color} size={size} icon={buttonIcon} onClick={handleMenuOpen} />
        <L2RMenu
            anchorEl={menuAnchor}
            onClose={handleMenuClose}
            open={Boolean(menuAnchor)}
            menuConfig={config}
            {...menuProps}
        />
    </>
}

MoreMenu.propTypes = {
    icon: PropTypes.node,
    menuConfig: PropTypes.arrayOf(PropTypes.shape({
        enabled: PropTypes.bool,
        id: PropTypes.string,
        label: PropTypes.string.isRequired,
        icon: PropTypes.node,
        props: PropTypes.object,
    })),
    color: PropTypes.oneOf(["primary", "secondary", "tertiary"]),
    direction: PropTypes.oneOf(["vertical", "horizontal"]),
    size: PropTypes.oneOf(["small", "medium", "large"]),
}

MoreMenu.defaultProps = {
    menuConfig: [],
    color: "primary",
    direction: "vertical",
    size: "small",
}